import { isDevMode } from 'whisper-base';
import { captureMessage as sentryCaptureMessage, captureError as sentryCaptureError } from './sentryApi';
const {
  captureMessage,
  captureError
} = isDevMode() ? {
  captureMessage: () => {},
  captureError: () => {}
} : {
  captureMessage: sentryCaptureMessage,
  captureError: sentryCaptureError
};
export { captureMessage, captureError };